<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">编辑住院信息</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="no">
					<span style="width:85px;display: inline-block;text-align: right;">住院单号：</span>
					{{detail.id}}
				</div>
				<div class="msg">
					<div class="item">
						<div class="label">顾客姓名：</div>
						<div class="value">{{detail.memberName}}</div>
					</div>
					<div class="item">
						<div class="label">手机号码：</div>
						<div class="value">{{detail.memberMobile}}</div>
					</div>
					<div class="item">
						<div class="label">宠物昵称：</div>
						<div class="value">{{detail.petName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物品种：</div>
						<div class="value">{{detail.typeName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物性别：</div>
						<div class="value">{{detail.sex}}</div>
					</div>
					<div class="item">
						<div class="label">宠物年龄：</div>
						<div class="value" v-if="detail.birthDay&&detail.birthDay.length>4">
							{{$public.FTime(new Date(detail.birthDay).getTime(),'YYYY-MM-DD')}}
							<span style="color:#1853A4;">
								({{$public.FAge(new Date(detail.birthDay).getTime())[0]}}岁
								{{$public.FAge(new Date(detail.birthDay).getTime())[1]}}月)
							</span>
						</div>
					</div>
					<div class="item">
						<div class="label">住院服务：</div>
						<div class="value">{{detail.productName}} ( {{detail.inHospitalPrice}}元/天 )</div>
					</div>
					<div class="item">
						<div class="label">创建时间：</div>
						<div class="value">{{$public.FTime(detail.createTime,'YYYY-MM-DD HH:mm')}}</div>
					</div>
					<div class="item">
						<div class="label">住院开始时间：</div>
						<div class="value">{{$public.FTime(detail.beginDate,'YYYY-MM-DD')}}</div>
					</div>
					<div class="item">
						<div class="label">住院结束时间：</div>
						<div class="value">
							<el-date-picker style="width:140px" @change="changeZhuyuan('endDate')" v-model="form.timeRange" :picker-options="{disabledDate(time) {return form.timeRange.getTime() > time.getTime()}}" type="date" :clearable="false" size="small"></el-date-picker>
						</div>
					</div>
					<div class="item">
						<div class="label">已住院时间：</div>
						<div class="value">{{detail.inHospitalDuration}}</div>
					</div>
					<div class="item">
						<div class="label">押金：</div>
						<div class="value" v-if="detail.depositType==1">
							<el-input v-model="form.deposit" @change="changeZhuyuan" size="small" style="width:140px" placeholder="请输入押金">
								<template slot="append">元</template>
							</el-input>
						</div>
					</div>
					<div class="item">
						<div class="label">余额：</div>
						<div class="value" v-if="detail.depositType==2">{{detail.deposit}}</div>
					</div>
					<div class="item">
						<div class="label">支付方式：</div>
						<div class="value" v-if="detail.depositType==1">
							{{$public.formatPayTypeState(detail.payType)}}
						</div>
					</div>
					<div class="item">
						<div class="label">已支付住院费：</div>
						<div class="value">
							<span style="color:#32A05B">{{detail.payInHospitalMoney}}元</span>
						</div>
					</div>
					<div class="item">
						<div class="label">应支付住院费：</div>
						<div class="value">
							<span>{{detail.inHospitalMoney}}元</span>
						</div>
					</div>
					<div class="item">
						<div class="label">是否欠费：</div>
						<div class="value">
							<span v-if="$public.jian(detail.inHospitalMoney,detail.payInHospitalMoney)>0" style="color:red">是</span>
							<span v-else style="color:#32A05B;">否</span>
						</div>
					</div>
					<div class="item">
						<div class="label">已超时时间：</div>
						<div class="value">{{detail.overDuration}}</div>
					</div>
					<div class="item">
						<div class="label">紧急联系人：</div>
						<div class="value">
							<el-input v-model="form.contactName" @change="changeZhuyuan" size="small" style="width:140px" placeholder="请输入紧急联系人"></el-input>
						</div>
					</div>
					<div class="item">
						<div class="label">联系电话：</div>
						<div class="value">
							<el-input v-model="form.contactMobile" @change="changeZhuyuan" size="small" style="width:140px" placeholder="请输入联系电话"></el-input>
						</div>
					</div>
					<div class="item">
						<div class="label">经办人：</div>
						<div class="value">
							<el-select style="width:145px;" @change="changeZhuyuan" v-model="form.doctorIndex" placeholder="请选择" size="small">
								<el-option v-for="(item,index) in doctorList" :key="item._id" :label="item.basic_info.nick_name" :value="index">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="label">备注：</div>
						<div class="value">
							<el-input type="textarea" @change="changeZhuyuan" v-model="form.remark" :rows="3" style="width:140px" size="small" placeholder="请输入备注"></el-input>
						</div>
					</div>
				</div>
				<div class="relation">
					<div v-if="detail.status==1&&detail.payInfo.payCount===0">
						<span style="color:red;padding-right: 10px;">(未支付)</span>
						<el-button style="width:120px;" type="info" size="medium">离院</el-button>
					</div>
					<el-button v-if="detail.status==1&&detail.payInfo.payCount>0" style="width:120px;" type="success" size="medium" @click="leave">离院</el-button>
					<el-button v-if="detail.status==2" style="width:120px;" type="info" size="medium">已离院</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				nowDate:new Date().getTime().toString().substr(0,10),
				detail: [],
				doctorList:[],
				form:{
					timeRange:'',
					remark:'',
					deposit:'',
					contactName:"",
					contactMobile:"",
					doctorIndex:0,
				},
			}
		},
		computed:{
			zhuyuanParams(){
				return this.$store.state.yiliaoxin.zhuyuanParams;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			back(){
				this.$store.commit("yiliaoxin/remove_router")
				if(this.$store.state.yiliaoxin.router.length===0){
					this.zhuyuanParams.type = 'list'
					this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
					this.$store.commit('yiliaoxin/set_curBusiness','住院')
				}
				// if(
				// 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
				// ){
				// 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
				// 	return 
				// }
				// this.zhuyuanParams.type = 'list'
				// this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
			},
			changeZhuyuan(str){
				if(this.form.doctorIndex===''){
					this.$message({
						message: '请选择经办人！',
						type: 'error'
					});
					return ;
				}
				if(str==='endDate'){
					this.$confirm('该修改为不可逆操作，确定要修改结束时间?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.changeZhuyuan()
					}).catch(()=>{
						this.form.timeRange = new Date(parseInt(this.detail.endDate+'000'));
					})
				}else{
					let params = {
						"id": this.detail.id,
						"endDate": "",
						deposit:Number(this.form.deposit),
						"handlerId": this.doctorList[this.form.doctorIndex]._id,
						"handlerName": this.doctorList[this.form.doctorIndex].basic_info.nick_name,
						"contactMobile": this.form.contactMobile,
						"contactName": this.form.contactName,
						
						"remark": this.form.remark
					}
					if(this.form.timeRange){
						params.endDate = new Date(this.form.timeRange).getTime().toString().substr(0,10);
					}
					let loading = this.$loading()
					this.$http.post('/api/InHospital/Update', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				}
			},
			getDoctorList(){
				this.$util.getDoctorList().then(list=>{
					this.doctorList = list;
					for(let i=0;i<this.doctorList.length;i++){
						if(this.doctorList[i]._id==this.detail.handlerId){
							this.form.doctorIndex = i;
						}
					}
				})
			},
			getTableData(){
				let params = {
					"inHospitalId": this.zhuyuanParams.curRow.id,
				}
				this.$http.get('/api/InHospital/Detail', params).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
						this.form.timeRange = new Date(parseInt(this.detail.endDate+'000'));
						this.form.remark = this.detail.remark;
						this.form.deposit = this.detail.deposit;
						this.form.contactName = this.detail.contactName;
						this.form.contactMobile = this.detail.contactMobile;
						this.getDoctorList();
					}
				})
			},
			leave(){
				this.$confirm('确定要离院?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/InHospital/Leave', {inHospitalId:this.detail.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '离院成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:23px 0 20px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.no{
					font-size: 14px;color:$fontColor;font-weight: bold;padding:0 24px 24px;
				}
				.msg{
					display: flex;flex-wrap: wrap;padding:0 24px 8px;
					.item{
						width:20%;font-size: 12px;color:$fontColor;display: flex;padding-bottom:16px;
						.label{
							width:85px;text-align: right;line-height: 32px;
						}
						.value{
							text-align: left;line-height: 32px;
						}
					}
				}
				.relation{
					padding:0 24px 8px;text-align: right;
				}
			}
		}
	}
</style>
